export const tabToNormalizeTo = <T extends string>(
  requested: string | null,
  parsed: T | null,
  visible: readonly T[],
  fallback: T,
): T | null => {
  if (requested == null) return null;
  if (parsed != null && visible.includes(parsed)) return null;
  return fallback;
};
